import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { SkeletonAvatarList, SkeletonHeading, SkeletonFilter, SkeletonItem } from './main';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div<{ marginRight: string | number }>({
	marginTop: token('space.300'),
	marginLeft: token('space.500'),
	height: 'calc(100% - 24px)',
	display: 'flex',
	flexDirection: 'column',
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginRight: `${(props: any) => props.marginRight}px`,
	overflow: 'hidden',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export { ContentWrapper };
